<div class="overview-container">

  <!-- ADMIN DASHBOARD -->
   @if(loggedInUser){
<app-admin-dashboard [project]="'IIC-LAB'"></app-admin-dashboard>
   }

    <!-- SALES LEADS DASHBOARD -->

    @if(!loggedInUser){
<app-sales-dashboard  [project]="'IIC-LAB'"></app-sales-dashboard>
    }
</div>